import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Message } from '@domain/models';

@Component({
  selector: 'app-payment-result-validated',
  templateUrl: './payment-result-validated.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentValidatedResultComponent {
  readonly message = input.required<Message>();
}
